import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { SubstanceTypeEnum } from 'app/enums/substance-type-enum';
import { FormService } from 'app/services/form.service';

@Component({
  selector: 'app-principal-therapeutic-uses',
  templateUrl: './principal-therapeutic-uses.component.html',
  styleUrls: ['./principal-therapeutic-uses.component.scss']
})
export class PrincipalTherapeuticUsesComponent implements OnInit {
  @Input({required: true}) substanceType!: SubstanceTypeEnum;
  @ViewChild('principalTherapeuticUsesInput') principalTherapeuticUsesInput!: ElementRef;
  principalTherapeuticUses!: string;

  constructor(private formService: FormService) {}

  ngOnInit(): void {
    this.principalTherapeuticUses = this.currentForm.get('principalTherapeuticUses')?.value;
  }

  public clearPrincipalTherapeuticUsesInputField() {
    this.principalTherapeuticUses = '';
    this.currentForm.patchValue({'principalTherapeuticUses': ''});
    this.errorCheck();
  }

  public updatePrincipalTherapeuticUses(event: Event) {
    if(event && event.type === 'blur') {
      var target = document.activeElement;
      if(target && target.nodeValue === "cancel") {
        this.principalTherapeuticUses = '';
      }
    }
    this.currentForm.patchValue({'principalTherapeuticUses': this.principalTherapeuticUses});
    this.errorCheck();
  }

  public cancelUpdate() {
    this.principalTherapeuticUses = this.currentForm.get('principalTherapeuticUses')?.value;
    this.errorCheck();
  }

  get isRevisionSubstanceType() { 
    return this.substanceType === SubstanceTypeEnum.Revision;
  }

  get formFieldTitle() {
    if(this.isRevisionSubstanceType) {
      return `Indications/Therapeutic Claim`;
    }

    return `Principal therapeutic use(s)`;
  }

  private errorCheck() {
    const targetControl = this.currentForm.get('principalTherapeuticUses');
    
    if(!targetControl) {
      return;
    }

    // Force re-validation
    setTimeout(() => {
      targetControl.markAsTouched();
      targetControl.markAsDirty();
      targetControl.updateValueAndValidity();
    });
  }

  get currentForm(): FormGroup {
    return this.formService.getCurrentUsanFormValue();
  }

  public hasFieldValidationError(fieldName: string, errorName?: string): boolean {
    return this.formService.hasFieldValidationError(fieldName, errorName);
  }
}
